import React from 'react';
import TabsBase from './Tabs';

const Tabs = props => <TabsBase {...props} />;

export default Tabs;
